import Switch from './src';

export default {
  install(Vue) {
    Vue.component('DSwitch', Switch);
  }
};
